import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Colors } from 'modules/theme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  background-color: ${Colors.white};
`;

const IconWrap = styled.div`
  margin-bottom: 16px;
  color: ${Colors.gray4};
  font-size: 40px;
  line-height: 1;
  opacity: 0.7;
`;

const Text = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: ${Colors.gray8};
  line-height: 1.5;
  max-width: 360px;
`;

const ListEmpty = ({ message }) => (
  <Wrapper>
    <IconWrap className="fas fa-inbox" aria-hidden />
    <Text>{message || 'The list is empty'}</Text>
  </Wrapper>
);

ListEmpty.propTypes = {
  message: PropTypes.string,
};

export default ListEmpty;
